import { Layout } from "antd";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API } from "../../Config/API";
import Footer from "../../component/footer/footer";
import Header from "../../component/header";
import { POST } from "../../utils/apiCalls";
import "./styles.scss";

const { Content } = Layout;
const EnhancedEpaper = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const [selectedImage, setSelectedImage] = useState<string>();
  const [hoveredSection, setHoveredSection] = useState<any>(null);
  const [clickedSection, setClickedSection] = useState<any>(null);
  const [highlightAreas, setHighlightAreas] = useState<any[]>([]);
  const [imageDimensions, setImageDimensions] = useState<{
    width: number;
    height: number;
  }>({ width: 1, height: 1 });
  const newspaperRef = useRef<HTMLDivElement>(null);

  const isAuthenticated = useSelector((state: any) => state?.User?.auth);
  const navigate = useNavigate();
  const croppedSectionRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   loadData("Qatar", "2025-02-20");
  // }, []);
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format
    loadData("Qatar", today);
  }, []);

  useEffect(() => {
    if (data?.epapercollections?.length) {
      if (!selectedImage) {
        const defaultImage = data?.epapercollections[0]?.imageUrl;
        setSelectedImage(defaultImage);
      }
      generateHighlightAreas();
    }
  }, [data, selectedImage, imageDimensions]);

  // Auto-scroll to the newspaper image when it changes
  useEffect(() => {
    if (newspaperRef.current) {
      newspaperRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  }, [selectedImage]);

  const generateHighlightAreas = () => {
    if (!selectedImage || !data?.epapercollections) return;

    const currentPage = data.epapercollections.find(
      (page: any) => page.imageUrl === selectedImage
    );

    if (!currentPage || !currentPage.coords) return;

    const imgWidth = imageDimensions.width;
    const imgHeight = imageDimensions.height;

    const dynamicAreas = currentPage.coords.map((coord: any, index: number) => {
      const x = coord.startX * imgWidth;
      const y = coord.startY * imgHeight;
      const width = coord.width * imgWidth;
      const height = coord.height * imgHeight;

      return {
        id: index + 1,
        coordinates: { x, y, width, height },
      };
    });

    setHighlightAreas(dynamicAreas);
  };

  const handleImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    setImageDimensions({ width: img.clientWidth, height: img.clientHeight });
  };

  const loadData = async (edition: any, date: any, page?: any) => {
    try {
      setIsLoading(true);
      let url = API.EPAPER;
      let obj = {
        type: "all",
        edition: edition,
        limit: 8,
        createdAt: moment(date).format("YYYY-MM-DD"),
      };
      const response: any = await POST(url, obj);
      if (response?.length) {
        setData(response[0]);
      } else {
        setData([]);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const handleThumbnailClick = (imageUrl: any, index: number) => {
    if (isAuthenticated || index === 0) {
      setSelectedImage(imageUrl);
      setHoveredSection(null);
      setClickedSection(null);
    } else {
      navigate("/auth");
    }
  };

  const handleSectionHover = (section: any) => {
    setHoveredSection(section);
  };

  const handleSectionLeave = () => {
    setHoveredSection(null);
  };

  const handleSectionClick = (section: any) => {
    setClickedSection(section === clickedSection ? null : section);

    // Scroll to the cropped section when it appears
    if (section !== clickedSection && croppedSectionRef.current) {
      setTimeout(() => {
        croppedSectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100); // Small delay to ensure the DOM has updated
    }
  };

  const fallbackImage = data?.epapercollections?.length
    ? data?.epapercollections[0]?.imageUrl
    : "https://sproutsnews.com/wp-content/uploads/2019/11/import_placeholder.png";

  return (
    <>
      <Header />
      <Layout className="layout">
        <Content className="newspaper-content">
          <div className="container-fluid">
            <Row className="newspaper-body">
              <Col md={5}>
                <div className="cricket-news relative">
                  <div
                    ref={newspaperRef}
                    className="newspaper-image-container relative"
                    style={{ position: "relative" }}
                  >
                    <img
                      src={selectedImage || fallbackImage}
                      alt="E-Paper"
                      className="cricket-image w-full h-auto"
                      onLoad={handleImageLoad}
                    />

                    {!isLoading &&
                      highlightAreas?.map((section: any) => (
                        <div
                          key={section.id}
                          className="hover-area"
                          style={{
                            position: "absolute",
                            left: `${section.coordinates.x}px`,
                            top: `${section.coordinates.y}px`,
                            width: `${section.coordinates.width}px`,
                            height: `${section.coordinates.height}px`,
                            border:
                              hoveredSection?.id === section.id ||
                              clickedSection?.id === section.id
                                ? "2.5px solid #1677ff"
                                : "2px dashed rgba(255,255,255,0.5)",
                            backgroundColor:
                              hoveredSection?.id === section.id ||
                              clickedSection?.id === section.id
                                ? "rgba(22, 119, 255, 0.25)"
                                : "rgba(255,255,255,0.1)",
                            zIndex: 100,
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            boxShadow:
                              hoveredSection?.id === section.id ||
                              clickedSection?.id === section.id
                                ? "0 0 10px #1677ff"
                                : "none",
                          }}
                          onMouseEnter={() => handleSectionHover(section)}
                          onMouseLeave={handleSectionLeave}
                          onClick={() => handleSectionClick(section)}
                        />
                      ))}
                  </div>
                </div>
              </Col>

              {/* <Col md={3} className="ads-section">
                <div className="ads-container">
                  <img
                    src="https://variety.com/wp-content/uploads/2019/12/cheezit_teaser1_still.png"
                    alt="Ad 1"
                    className="ad-image"
                  />
                  <img
                    src="https://www.valueleaf.com/blog/wp-content/uploads/2023/08/Video-Ads-Vs-Banner-Ads.jpg"
                    alt="Ad 2"
                    className="ad-image"
                  />
                  <img
                    src="https://newspaperads.ads2publish.com/wp-content/uploads/2017/10/a-news-channel-that-tells-you-how-to-rise-with-india-ad-calcutta-times-24-10-2017.jpg"
                    alt="Ad 3"
                    className="ad-image"
                  />
                  <img
                    src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh6iRJkCqKvIJ4v7iIKuA3VumP3XHRM3OtRRj061WVtoeAFOznMFtSwZ4Gvbw-pQyhWjoEYpoVYQNrCuRBTC6G5XDv2W1YmYyo11Qe0hZo6Sb7QBl4mNskMpWuCQM2DQ8V7xTajh-wWuzmcu0YlHtn-IMiVZu46ccobDQbONvu6j9652yR3LCw7HuHh/s1963/Delhi_HT_24-3-2023_Page_05.jpg"
                    alt="Ad 4"
                    className="ad-image"
                  />
                </div>
              </Col> */}
              {/* above i changed col 3 to 6  */}
              <Col md={6} className="thumbcontainer">
                <div className="section-thumbnails">
                  <Row>
                    {data?.epapercollections?.map(
                      (item: any, index: number) => (
                        <Col xs={6} key={index}>
                          <div
                            className={`thumbnail-box ${
                              selectedImage === item?.imageUrl
                                ? "selected-thumbnail"
                                : ""
                            }`}
                            onClick={() =>
                              handleThumbnailClick(item?.imageUrl, index)
                            }
                          >
                            <div className="number">{index + 1}</div>
                            <img
                              className="thumbnail-img"
                              src={item?.imageUrl}
                              alt={`Page ${index + 1}`}
                            />
                          </div>
                        </Col>
                      )
                    )}
                  </Row>
                </div>
              </Col>
              <Col md={12}>
                <div ref={croppedSectionRef}>
                  {clickedSection && selectedImage && (
                    <div className="mt-4 p-4 shadow-lg rounded-lg transition-all duration-300 bg-white">
                      <div
                        className="crop-container"
                        style={{
                          width: "100%",
                          marginTop: "10px",
                          marginBottom: "10px",
                          height: `${
                            clickedSection.coordinates.height * 2.5
                          }px`,
                          maxWidth: `${
                            clickedSection.coordinates.width * 2.5
                          }px`,
                          marginLeft: "auto",
                          marginRight: "auto",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            width: `${clickedSection.coordinates.width}px`,
                            height: `${clickedSection.coordinates.height}px`,
                            backgroundImage: `url(${selectedImage})`,
                            backgroundPosition: `-${clickedSection.coordinates.x}px -${clickedSection.coordinates.y}px`,
                            backgroundSize: `${imageDimensions.width}px ${imageDimensions.height}px`,
                            backgroundRepeat: "no-repeat",
                            transform: "scale(2.5)",
                            transformOrigin: "top left",
                            position: "absolute",
                            top: 0,
                            left: 0,
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </Content>
        <Footer />
      </Layout>

      <style>{`
        .newspaper-image-container {
          position: relative;
          display: inline-block;
        }
        
        .hover-area {
          pointer-events: auto;
        }
        
        .cricket-news {
          position: relative;
        }
        
        .selected-thumbnail {
          border: 2px solid #1677ff;
          box-shadow: 0 0 5px rgba(22, 119, 255, 0.5);
        }
        
        @keyframes pulse {
          0% { box-shadow: 0 0 0 0 rgba(22, 119, 255, 0.7); }
          70% { box-shadow: 0 0 0 10px rgba(22, 119, 255, 0); }
          100% { box-shadow: 0 0 0 0 rgba(22, 119, 255, 0); }
        }
        
        .hover-area:hover {
          animation: pulse 1.5s infinite;
        }
        
      .crop-container {
    border-radius: 8px;
    position: relative;
    overflow: visible; // Changed from hidden to visible
    width: 100%;
    display: block;
  }
  
  // Ensure the container can accommodate the scaled content
  .crop-container > div {
    display: block;
    max-width: none;
  }
      `}</style>
    </>
  );
};

export default EnhancedEpaper;
